export default __webpack_public_path__ + "static/media/back-end.391475dd.svg";